<template>
  <v-container fluid>
    <section v-if="usersAndRolesAllowed">
      <h5 class="wc-h5 mb-4">Modificar estatus del miembro</h5>
      <span>En este apartado podrás cambiar el status del miembro.</span>
      <v-row class="mt-2 mb-8">
        <v-col md="6" sm="12" class="pb-0">
          <v-select
            filled
            dense
            rounded
            label="Nuevo estatus del miembro"
            :items="statusListComputed"
            v-model="selectedStatus"
          >
          </v-select>
        </v-col>
        <v-col cols="12">
          <v-form v-model="membershipTypeSelected">
            <v-row>
              <v-col sm="6" md="6" v-if="selectedStatus == 'ACTIVE'">
                <v-select
                  filled
                  dense
                  rounded
                  persistent-hint
                  v-model="selectedAffiliation"
                  item-text="name"
                  item-value="_id"
                  label="Tipo de membresía"
                  :hint="getPeriodicityLabel()"
                  :rules="[(v) => !!v || 'El tipo de membresía es requerida']"
                  :items="availableAffiliationTypes"
                  :autofocus="true"
                >
                </v-select>
              </v-col>
              <v-col sm="6" md="4" v-if="selectedStatus == 'ACTIVE'">
                <v-text-field
                  v-model="affiliationPrice"
                  type="number"
                  dense
                  label="Monto"
                  filled
                  rounded
                  @keyup="validateMembershipPrice()"
                />
              </v-col>
              <v-col sm="6" md="4" v-if="selectedStatus == 'ACTIVE'">
                <v-menu
                  v-model="datePickerMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="paymentDateFormatted"
                      label="Fecha de pago"
                      prepend-icon="mdi-calendar"
                      readonly
                      filled
                      dense
                      rounded
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="paymentDate"
                    @input="datePickerMenu = false"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col sm="6" md="4" v-if="selectedStatus == 'ACTIVE'">
                <v-menu
                  v-model="inactivationDatePickerMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="inactivationDateFormatted"
                      label="Fecha de inactivación"
                      prepend-icon="mdi-calendar"
                      readonly
                      filled
                      dense
                      rounded
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="inactivationDate"
                    @input="inactivationDatePickerMenu = false"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row v-if="selectedStatus == 'ACTIVE'">
              <v-col cols="12">
                <v-btn
                  elevation="0"
                  :disabled="!selectedAffiliation"
                  class="white--text text-bold rounded-pill"
                  :color="color.primaryVariant"
                  @click="$_handleUpdateUserStatus()"
                >
                  <v-icon class="mr-2"> mdi-content-save </v-icon>
                  Actualizar Estatus
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="selectedStatus != 'ACTIVE' && selectedStatus != ''">
              <v-col cols="12">
                <v-btn
                  elevation="0"
                  class="white--text text-bold rounded-pill"
                  :color="color.primaryVariant"
                  @click="$_handleUpdateUserStatus()"
                >
                  <v-icon class="mr-2"> mdi-content-save </v-icon>
                  Actualizar Estatus
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </section>

    <h5 class="wc-h5 mb-4">Gestionar Contraseñas</h5>
    <span> En este apartado podrás restablecer la contraseña del miembro </span>
    <div class="mt-8">
      <v-radio-group
        v-model="passwordRecoverOption"
        class="recover-password-group"
        hide-details
      >
        <v-radio
          label="Cambiar manualmente la contraseña del usuario"
          value="changePasswordManual"
        />
        <v-radio
          label="Enviar enlace por correo para restablecer contraseña"
          value="sendRecoveryEmail"
        />
      </v-radio-group>
    </div>
    <div md="3">
      <v-row no-gutters>
        <v-col cols="12" v-if="passwordRecoverOption == 'changePasswordManual'">
          <v-col md="12">
            <span class="pa-0 ma-0">
              Establecer nueva contraseña para el usuario.
            </span>
          </v-col>
          <v-col sm="12" md="6">
            <v-form v-model="resetPasswordForm">
              <v-text-field
                label="Nueva contraseña del miembro"
                filled
                dense
                rounded
                v-model="newPassword"
                :type="showPass ? 'text' : 'password'"
                :rules="[...passwordRules]"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass"
              >
              </v-text-field>
            </v-form>
          </v-col>
        </v-col>
        <v-col sm="12" md="12">
          <v-btn
            elevation="0"
            :disabled="
              passwordRecoverOption != 'sendRecoveryEmail'
                ? !resetPasswordForm
                : false
            "
            :color="color.primaryVariant"
            class="rounded-pill text-uppercase text-bold white--text"
            @click="() => (dialogSwitch = true)"
          >
            <!-- <v-icon>
                      mdi-send
                    </v-icon> -->
            {{
              passwordRecoverOption == "changePasswordManual"
                ? "Restablecer contraseña"
                : "Enviar correo"
            }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <personalized-dialog
      :dialog="dialogSwitch"
      @save="$_handleResetPassword()"
      @discard="() => (dialogSwitch = false)"
    >
      <template #alertName>
        <h5>
          {{ confirmationMessages[passwordRecoverOption].title }}
        </h5>
      </template>
      <template #alertContent>
        <span style="font-size: 16px; text-align: center">
          {{ confirmationMessages[passwordRecoverOption].value }}
        </span>
      </template>
    </personalized-dialog>
  </v-container>
</template>
<script>
import PersonalizedDialog from "./PersonalizedDialog.vue";
import { homologateStatusWithColor } from "@/common/hook/useHelper.js";
import { colors } from "@/constants/colors.js";
import { mapMutations, mapState } from "vuex/dist/vuex.common.js";
import { validations } from "@/share/validations";
import { isImefOrganization } from "../../share/imef";
import { isClub51Organization, isOrganization } from "@/share/validateOrganization";
import moment from "moment";
import { getInactivationDateCalc, momentDate  } from "../../share/inactivationDateCalc.js";

export default {
  props: {
    memberId: {
      type: String,
      default: "",
    },
    memberEmail: {
      type: String,
      default: "",
    },
    memberStatus: {
      type: String,
      default: "",
    },
    availableAffiliationTypes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    PersonalizedDialog,
  },
  data() {
    return {
      passwordRecoverOption: "changePasswordManual",
      newPassword: "",
      resetPasswordForm: true,
      passwordRules: validations.newPasswordRule(),
      showPass: true,
      color: colors,
      dialogSwitch: false,
      membershipTypeSelected: null,
      selectedStatus: "",
      selectedAffiliation: null,
      affiliationPrice: 0,
      paymentDate: new Date().toISOString().split('T')[0], // Fecha actual por defecto
      inactivationDate: new Date().toISOString().split('T')[0], // Fecha actual por defecto
      datePickerMenu: false,
      inactivationDatePickerMenu: false,
      userStatusList: [
        {
          text: "Activo",
          value: "ACTIVE",
        },
        {
          text: "Inactivo",
          value: "INACTIVO",
        },
        {
          text: "Expirado",
          value: "EXPIRED",
        },
      ],
      periodLabels: {
        YEAR: "Anual",
        MONTH: "Mensual",
        TRIMESTER: "Trimestral",
      },
      confirmationMessages: {
        changePasswordManual: {
          value:
            "Estás a punto de confirmar el restablecimiento de la contraseña. ¿Deseas continuar?",
          title: "Confirmar Restablecimiento de Contraseña",
          url: "/authentication/reset-member-password",
          response:
            "La contraseña del usuario ha sido restablecida correctamente",
        },
        sendRecoveryEmail: {
          value:
            "Estás a punto de confirmar el envío del correo para restablecer la contraseña. ¿Deseas continuar?",
          title: "Confirmar Envío de Correo",
          url: "/authentication/password-recover",
          response:
            "El enlace ha sido enviado al correo del usuario correctamente.",
        },
      },
    };
  },
  methods: {
    ...mapMutations("notification", ["show"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    homologateStatusWithColor,
    isImefOrganization,
    isClub51Organization,
    isOrganization,
    disableOptions(statusArray = []) {
      if (this.isClub51Organization(this.user._id, this.user.organization)) {
        this.userStatusList = [
          {
            text: "Baja Temporal",
            value: "TEMPORALLY_LEAVE",
          },
          ...this.userStatusList,
        ];
      }
      if (statusArray.length <= 0) return [...this.userStatusList];

      let disabledStatusArray = [...this.userStatusList].reduce(
        (accum, currentStatus) => {
          if (![...statusArray].includes(currentStatus.value))
            return [...accum, currentStatus];
          return [...accum, { ...currentStatus, disabled: true }];
        },
        []
      );

      return disabledStatusArray;
    },

    async $_handleResetPassword() {
      this.loading();
      try {
        const passwordDirective =
          this.confirmationMessages[this.passwordRecoverOption];
        const payload = {
          memberId: this.memberId,
          updatedPassowrd: this.newPassword,
          email: this.memberEmail,
        };

        const response = await this.axios({
          url: passwordDirective.url,
          method: "POST",
          data: payload,
        });
        if (response.status == 200) {
          this.show({
            text: passwordDirective.response,
            color: "success",
          });
        }
      } catch (error) {
        console.log(error);
        this.show({
          text: "Hubo un error al restablecer la contraseña del usuario, por favor intenta nuevamente",
          color: "error",
        });
      } finally {
        this.newPassword = "";
        this.loaded();
      }
    },

    async $_handleUpdateUserStatus() {
      try {
        const requestData = {
          memberId: this.memberId,
          status: this.selectedStatus,
          membershipId: this.selectedAffiliation,
          total: this.affiliationPrice,
        };

        if (this.selectedStatus === 'ACTIVE') {
          const selectedDate = new Date(this.paymentDate + 'T12:00:00');
          requestData.paymentDate = selectedDate;

          const inactivationDate = new Date(this.inactivationDate);
          requestData.inactivationDate = inactivationDate;
        }

        let response = await this.axios({
          url: "/users/update-status-manually",
          method: "POST",
          data: requestData,
        });
        if (response.status == 200) {
          this.show({
            text: "El estatus del miembro ha sido actualizado exitosamente",
            color: "success",
          });
        }
      } catch (error) {
        const text = error?.response?.data?.error?.message ||
          "Hubo un error al actualizar el estatus del miembro, por favor intenta nuevamente";
        this.show({
          text,
          color: "error",
        });
      } finally {
        this.$emit("update");
        this.resetData();
      }
    },

    validateMembershipPrice() {
      this.affiliationPrice = parseInt(this.affiliationPrice);
      if (this.affiliationPrice < 0) {
        this.affiliationPrice = 0;
      }
    },

    findAffiliationById(id = null) {
      const affiliations = [...this.availableAffiliationTypes];

      if (affiliations.length <= 0 || id == null ) return null;

      return affiliations.find(
        (e) => e._id === id
      )
    },

    getAffiliationPrice(currentAffiliation = "") {
      return this.findAffiliationById(currentAffiliation)?.price || 0;
    },

    resetData() {
      this.selectedStatus = "";
      this.affiliationPrice = 0;
      this.selectedAffiliation = null;
      this.paymentDate = new Date().toISOString().split('T')[0]; // Reset a fecha actual
      this.datePickerMenu = false;
      this.userStatusList = [
        {
          text: "Activo",
          value: "ACTIVE",
        },
        {
          text: "Inactivo",
          value: "INACTIVO",
        },
        {
          text: "Expirado",
          value: "EXPIRED",
        },
      ];
    },

    getPeriodicityLabel() {
      if (!this.selectedAffiliation) return '';

      let label = 'Esta membresía tiene una periodicidad ';
      let staticDate = ''

      const { period = 'YEAR', expirationDatesConfig = null } = this.findAffiliationById(this.selectedAffiliation);

      label += this.periodLabels[period]

      if (!!expirationDatesConfig?.isStaticInactive && period == 'YEAR') {
        staticDate = ' con fecha fija de vencimiento el: ' + moment()
          .month(expirationDatesConfig?.inactivationMonth - 1)
          .date(expirationDatesConfig?.inactivationDay)
          .format(' D [de] MMMM');
      }

      return label + staticDate
    },


    calculateExpirationDate(periodicity) {
      const increments = {
        YEAR: [1, 'year'],
        MONTH: [1, 'month'],
        TRIMESTER: [3, 'months'],
      }

      const [value, unit] = increments[periodicity];
      return moment().add(value, unit).format('D [de] MMMM [de] YYYY');
    }
  },

  watch: {
    selectedAffiliation(next) {
      this.affiliationPrice = this.getAffiliationPrice(next);
      const { period = 'YEAR', expirationDatesConfig = null } = this.findAffiliationById(next)
      const inactivateDate =  getInactivationDateCalc(period, expirationDatesConfig?.inactivationDay, expirationDatesConfig?.inactivationMonth, expirationDatesConfig?.isStaticInactive)

      this.inactivationDate = inactivateDate.toISOString();
    },
  },

  computed: {
    ...mapState("user", ["user"]),

    // PATCH(IMEF) - Add validation for enable status update section only for HEAD_OFFICE
    usersAndRolesAllowed() {
      const { _id = "", organization = "", role = "" } = this.user;
      let isImef = this.isOrganization( "imef" , _id, organization);

      if(!isImef) return true; // If it's not IMEF, show the section without validating the role

      return (
        ["HEAD_OFFICE"].includes(role)
      );
    },

    isOneLevelOrganization() {
      return this.user.hierarchyType == 'ONE_LEVEL'
    },

    statusListComputed() {
      let listToDisplay = [];
      let statusToBlock = [];
      statusToBlock.push(this.memberStatus);
      switch (this.memberStatus) {
        case "PROSPECTO":
          statusToBlock.push(...["INACTIVO", "EXPIRED"]);
          break;
        case "ACTIVE":
          statusToBlock.push("EXPIRED");
          break;
      }
      console.log(this.memberStatus);
      console.log(statusToBlock);
      listToDisplay = this.disableOptions(statusToBlock);
      return listToDisplay;
    },

    paymentDateFormatted() {
      if (!this.paymentDate) return '';
      const date = new Date(this.paymentDate + 'T12:00:00'); // Evitar problemas de zona horaria
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    inactivationDateFormatted() {
      const date = momentDate(this.inactivationDate)
      this.inactivationDate = date.toISOString();
      return date.toLocalString()
    },
  },
};
</script>
